import { render, staticRenderFns } from "./PartidaBalaDetail.vue?vue&type=template&id=1067c81a&scoped=true"
import script from "./PartidaBalaDetail.vue?vue&type=script&lang=js"
export * from "./PartidaBalaDetail.vue?vue&type=script&lang=js"
import style0 from "./PartidaBalaDetail.vue?vue&type=style&index=0&id=1067c81a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1067c81a",
  null
  
)

export default component.exports